module.exports = __webpack_public_path__ + "media/fonts/Quicksand-Regular-cffc279022b0d87c571dff78071828f9.ttf";